const { search } = window.location;
const params = new URLSearchParams(search);
const locale = params.get("locale");
localStorage.setItem(
  "locale",
  locale ? `"${locale}"` : localStorage.getItem("locale") || `"en"`
);

export {};
